const STATS = [
  { value: "Reduce Cost", label: "Eliminate manual, repetitive work" },
  { value: "Reduce Risk", label: "Full accountability, full traceability" },
  { value: "Complete Visibility", label: "Real time visibility with centralized records" },
];

export function Outcomes() {
  return (
    <section
      id="outcomes"
      className="bg-brand-navy text-brand-cream py-20 md:py-28"
      data-testid="outcomes-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <p
          className="text-[11px] md:text-[13px] uppercase tracking-[0.45em] text-brand-cream/55 mb-4 text-center"
          data-testid="outcomes-eyebrow"
        >
          What you gain
        </p>
        <h2
          className="text-center font-poppins font-semibold text-3xl md:text-5xl tracking-tight leading-tight"
          data-testid="outcomes-heading"
        >
          Total clarity. Without complexity.
        </h2>

        <div className="mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-3 gap-y-12 gap-x-6 text-center">
          {STATS.map((s) => (
            <div
              key={s.label}
              className="px-2"
              data-testid={`outcome-${s.label.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
            >
              <div className="font-poppins font-semibold text-2xl md:text-4xl tracking-tight text-brand-cream whitespace-nowrap">
                {s.value}
              </div>
              <div className="mt-3 text-[11px] uppercase tracking-[0.25em] text-brand-cream/65">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
